import React from 'react';
import ym from 'react-yandex-metrika';
import { FormattedMessage } from 'react-intl';
import { EDITOR_TYPES, RobotSampleVisible } from '../robot.types';
import { useEditor, useRobotSelector } from '../context';
import { useMe } from '../../../utils/hooks/useMe';
import { useFeatureFlags } from '../../app-factory/context';
import { Button } from '../../button/button';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot__open-sandbox-button.module.scss';

export const RobotOpenSandboxButton = () => {
    const me = useMe();
    const createdFrom = useRobotSelector((s) => `${s.problem.id}:${s.sample}`);
    const field = useRobotSelector((s) => (s.samples[s.sample] as RobotSampleVisible).field);
    const featureFlags = useFeatureFlags();
    const isRobotSandboxEnabled = featureFlags.robotSandbox;
    const { editor } = useEditor();
    const code = useRobotSelector((s) => s.code);
    if (!(me && field && isRobotSandboxEnabled)) {
        return null;
    }
    const getUrl = () => {
        switch (editor) {
            case EDITOR_TYPES.BLOCKLY_PYTHON:
                return '/classroom/robot-sandbox-blockly/';
            case EDITOR_TYPES.PYTHON:
            default:
                return '/classroom/robot-sandbox/';
        }
    };
    return (
        <Button
            className={styles.sandbox_open_button}
            onClick={() => {
                try {
                    const initialSandboxData = { createdFrom, field, defaultValue: code?.answer };
                    sessionStorage.setItem('robot-sandbox-init', JSON.stringify(initialSandboxData));
                    window.open(getUrl(), '_blank');
                    ym('reachGoal', 'robot_sandbox_open');
                    return;
                } catch (e) {
                    console.error(e);
                }
            }}
            rounded
            size={Button.SIZE.S}
            view={Button.VIEW.SECONDARY}
        >
            <FormattedMessage id="robotSandbox.open" />
        </Button>
    );
};
